module.exports = __webpack_public_path__ + "static/media/media.575af169.svg";